import { sponsoredLabel } from './translations';

export const getSponsoredLabelText = () => sponsoredLabel;
